export default {
      id: "ind-tick-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#ind-tick",
      toString: function () {
        return this.url;
      }
    }